import gql from 'graphql-tag'

export default gql`
  query StudentUsersPaginated($page: Int!, $perPage: Int!, $search: String) {
    studentUsersPaginated(page: $page, perPage: $perPage, search: $search) {
      items {
        _id
        username
        firstname
        lastname
        avatar
        email
        mobile
      }
      total
      page
      perPage
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`
